import { TableIcon } from "./TableIcon";

export const VerticleTableIcon = (props) => <TableIcon shape="verticalRectangle" {...props} />;
